import { ScopeType } from 'src/common/types';
import DataStore, { Query } from 'src/core/stores/data-store';
import FormStore from 'src/core/stores/form-store';

import {
  CreateOrganizationItem,
  OrganizationBackupItem,
  OrganizationItem,
  OrganizationMemberItem,
  OrganizationSummary,
} from 'src/stores/organizations-store';
import { OrganizationsSummaryMockData } from '../data-sources/organization-summary';
import { OrganizationItemMockData } from '../data-sources/organization-item';
import { DatabasesCheckMockData } from '../data-sources/databases-check';
import FormStoreMock from './base/form-store';
import DataStoreMock from './base/data-store';
import { OrganizationBackupsMockData } from '../data-sources/organization-backups';

export class OrganizationSummaryStoreMock extends DataStore<OrganizationSummary> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/organizations`, []);
  }

  public async load(_query: Partial<Query>) {
    this._state.set({
      isBusy: false,
      errorMessage: undefined,
      items: OrganizationsSummaryMockData,
      count: OrganizationsSummaryMockData.length,
    });
    return true;
  }

  public async getAll(): Promise<OrganizationSummary[]> {
    return OrganizationsSummaryMockData;
  }

  public async delete(id: string, params?: any) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async organizationExists(id: string) {
    return true;
  }
}

export class OrganizationItemStoreMock extends FormStore<OrganizationItem, CreateOrganizationItem> {
  private exportingStatus = true;
  public async load(id: string): Promise<any> {
    this._state.set({
      isBusy: false,
      errorMessage: undefined,
      item: OrganizationItemMockData,
    });
    return OrganizationItemMockData;
  }

  public async getOrganizationData(id: string) {
    return await this.handleCallAsync(async () => {
      return OrganizationItemMockData;
    });
  }

  public async switchMFA(id: string, newValue: boolean) {
    return { isSuccess: true, error: '', messages: [] };
  }

  OrganizationMembersBasePath = 'users';
  RestartOrganizationCreationFlowBasePath = 'restart-creation-flow';
  ChangeBlockStateBasePath = 'change-block-state';
  sendInvitationPath = 'send-invitation';
  checkOrganizationDatabasePath = 'check-db';
  fixScopesSyncIssuesPath = 'fix-scopes-sync-issues';

  public async create(item: CreateOrganizationItem) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async fixScopesSyncIssues(orgId: string, justCheck = false, scopeType: ScopeType | null = null) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async restartOrganizationCreationFlow(id: string) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async checkOrganizationDatabase(id: string) {
    return { isSuccess: true, message: '' };
  }

  public async checkAllOrganizationsDatabases() {
    return DatabasesCheckMockData;
  }

  public async addOrganizationMembers(id: string, userIdOrEmails: OrganizationMemberItem[]) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async deleteOrganizationMembers(id: string, userIds: string[]) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async changeOrganizationBlockStatus(id: string, isBlocked: boolean) {
    return {
      isSuccess: true,
      identity: 'fc7c3553-d3ea-4538-9192-08db83c643a8',
      error: '',
      messages: [],
    };
  }

  public async sendInvitation(id: string, userId: string) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public setExportingStatus(newStatus: boolean) {
    this.exportingStatus = newStatus;
  }

  public async checkExportingStatus(id: string) {
    return { count: 0, items: [] };
  }

  public async checkLockedStatus(id: string) {
    return false;
  }
}

export class OrganizationImportStoreMock extends FormStoreMock<any, any> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/export-import/api/backup`);
  }

  public async uploadOrganizationBackup(file: File) {
    return {
      isSuccess: true,
      error: '',
    };
  }

  public async exportFile(organizationId: string, fileName: string) {
    return { isSuccess: true, error: '', messages: [] };
  }
}

export class OrganizationBackupStoreMock extends DataStoreMock<OrganizationBackupItem> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/organizations-backup`);
  }

  public async loadSelected(query: Partial<Query>, selectedIds: string[]) {
    return true;
  }

  public async getByOrganizationId(organizationId: string) {
    return OrganizationBackupsMockData;
  }

  public async restoreOrganization(backupId: string) {
    return { isSuccess: true, message: '' };
  }

  public async generateDownloadUrl(backupId: string, organizationId: string) {
    return { isSuccess: true, url: '' };
  }
}
